import baseConfig from './config'

// Merge base config with runtime overrides (set via config.override.js in index.html)
const appConfig = {
  ...baseConfig,
  ...(typeof window !== 'undefined' && window.configOverride ? window.configOverride : {})
};

export default appConfig;
